import React from 'react';

import { Error404 } from '../../components/index';

const ErrorPage = () => {
  return <Error404 />;
};

export default ErrorPage;
